import { createAction } from '@reduxjs/toolkit';
import { AppThunk } from '../../store';
import { changeAppStatus, listAdminAvailableProjects } from '../../../services/DevPortalService';
import { PROJECT_STATUS } from '../../../interfaces/project';
import { ApplicationManagerInterface } from '../../../interfaces/application';

// Actions

export const getAdminAppsError = createAction<string>('GET_ADMIN_APPS_ERROR');
export const resetAdminApps = createAction('RESET_ADMIN_APPS');

// Thunk Actions

export const getAdminAppsAction = createAction<ApplicationManagerInterface[] | undefined>(
  'GET_ADMIN_APPS',
);
export const getAdminApps = (): AppThunk => async (dispatch, getState) => {
  try {
    const take = 1000;
    const skip = 0;

    const currentApps = getState().adminAppReducer.apps;

    if (currentApps && currentApps?.length > 0) return;

    const res = await listAdminAvailableProjects(take, skip);

    return dispatch(getAdminAppsAction(res.parsedBody));
  } catch (e) {
    return dispatch(getAdminAppsError('Error fetching applications.'));
  }
};

export const editAdminAppStatusAction = createAction<ApplicationManagerInterface[] | undefined>(
  'EDIT_ADMIN_APPS_STATUS',
);

export const editAdminAppStatus =
  (applicationId: string, status: PROJECT_STATUS, reason?: string): AppThunk =>
  async (dispatch, getState) => {
    try {
      const body = { reason: reason || '' };

      const res = await changeAppStatus(applicationId, status, body);

      if (res.parsedBody) {
        const currentApps = getState().adminAppReducer.apps;

        const newApps = currentApps?.map((project) => {
          if (project.application.info.applicationId === applicationId) {
            return {
              application: res.parsedBody?.app || project.application,
              organisation: project.organisation,
            };
          }

          return project;
        });

        return dispatch(getAdminAppsAction(newApps));
      }
    } catch (e) {
      return dispatch(getAdminAppsError('Error updating application status.'));
    }
  };
